import React, { KeyboardEvent, useContext, useDeferredValue, useEffect, useState } from "react"
import { Loading } from "../components/Loading";
import { ProcedureChartModal } from "./procedure-charts";
import { columns, ProcedureReportTable } from "./procedure-report-columns";
import { ProcedureSettingsButton } from "./procedure-settings";
import { loadProcedureReport, ProcedureContext, ProcedureStore } from "./procedure-store"

function FilterBox(){
    const [text, setText] = useState("");
    const {dispatch} = useContext(ProcedureContext);
    
    function doFilter(e:KeyboardEvent){
        if(e.key == "Enter"){
            dispatch({type: 'setFilter', filter: text})
        }
    }

    return <input enterKeyHint="search" 
        onKeyUp={doFilter}
    placeholder="Busca..." className="form-control" value={text} onChange={e => setText(e.target.value)} />
}

function Header(){
    return <div className="d-flex p-3 align-items-start procedure-page-header">
        <img src="royal-logo-white.png" className="h-light me-4" style={{opacity:.8, maxWidth:'110px'}} />
        <img src="royal-logo.png" className="h-dark me-4" style={{opacity:.8, maxWidth:'110px'}} />
        <h2><small className="opacity-75">Dashboard</small> Detalhes por Procedimento</h2>
        <div className="flex-grow-1 d-flex justify-content-end procedure-tools">
            <FilterBox />
            <ProcedureSettingsButton />
        </div>
    </div>
}

function ProdureList(){
    const {state, dispatch} = useContext(ProcedureContext);
    const [error, setError] = useState("");

    useEffect(()=>{
        (async function(){
            try{
                const data = await loadProcedureReport();
                dispatch({type: "setData", data});
            }catch(e){
                setError("Falha ao carregar dados.")
            }
        })();
    }, [])

    if(error)
        return <div>Error</div>

    if(!state.data)
        return <div className="p-4"><Loading /></div>

    return <div className="procedure-table flex-grow-1 overflow-auto">
        <ProcedureReportTable data={state.data} columns={columns} onClick={(selected) => dispatch({type: "select", selected})} />
    </div>
}

export function ProcedureReportPage(){
    return <ProcedureStore>
            <div className="h-100 d-flex flex-column">
                <Header />
                <ProdureList />
            </div>
            <ProcedureChartModal />
        </ProcedureStore>
}